<div class="card-link-offer-location-list container" [class.expanded]="pageNo > 1">
  <div class="row" 
       [@.disabled]="!showAnimation"
       [@growAnimation]="{ value: pageNo, params: { height: listHeight } }" 
       [@shrinkAnimation]="{ value: pageNo, params: { start: intialHeight, end: listHeight }}" 
       #listContainer>
    <ng-container *ngFor="let location of cardLinkOfferLocationDetails | slice: 0 : pageNo * pageSize">
      <div class="col-lg-6 col-12 mb-4">
        <p class="card-link-offer-location-city">{{ location.City }}</p>
        <p class="card-link-offer-location-address">{{ location.Address }}</p>
      </div>
    </ng-container>
  </div>
  <hr class="horizontal-line" />
  <div class="d-flex align-content-center justify-content-center">
    <a
      class="show_more_button d-flex align-content-center justify-content-center"
      *ngIf="pageNo < totalPage"
      (click)="showMore()"
    >
      <span class="icon material-icons"> expand_more </span>
      {{ 'fgbcl.card.link.location.show.more.btn.text' | translate }}
    </a>
    
    <a
      class="hide_button d-flex align-content-center justify-content-center"
      *ngIf="pageNo !== 1"
      (click)="showLess()"
    >
      {{ 'fgbcl.card.link.location.show.less.btn.text' | translate }}
    </a>
  </div>
</div>
